import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Trash2, AlertTriangle } from 'lucide-react';

export const BulkDeleteDialog = ({ 
  open, 
  onOpenChange, 
  selectedCount,
  hardDelete, 
  onHardDeleteChange,
  loading,
  onConfirm 
}) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !loading && onOpenChange(open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <Trash2 className="w-5 h-5" />
            Bulk Delete Employees
          </DialogTitle>
          <DialogDescription>
            You are about to delete <strong>{selectedCount}</strong> employees. This action will affect all selected records.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="flex items-center gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
            <div className="text-sm text-amber-800">
              <p className="font-medium">Soft Delete (Recommended)</p>
              <p className="text-amber-600">Employees will be marked as deleted and can be restored later.</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="bulkHardDelete"
              checked={hardDelete}
              onChange={(e) => onHardDeleteChange(e.target.checked)}
              className="rounded border-slate-300"
            />
            <label htmlFor="bulkHardDelete" className="text-sm text-slate-700">
              Permanently delete all selected (cannot be undone)
            </label>
          </div>
          {hardDelete && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-700">
                <strong>Warning:</strong> This will permanently remove {selectedCount} employee records and their user accounts. This action cannot be undone.
              </p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-bulk-delete"
          >
            {loading ? 'Deleting...' : `Delete ${selectedCount} Employees`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkDeleteDialog;
